'use strict';

function MortgageRatesComparison() {
  this.node = null;
  this.declaredClass = null;
  this.extends = [];
  this.analytics = new Analytics();
  this._contentful = null;
  this._products = [];
  this._currentProduct = null;
  this._$node = null;
  this._$ratesContainer = null;
  this._$selectProduct = null;
  this.onComplete = function noop() {}; // Default Callback

  this.init = function () {
    // MKTG-375: mortgage + featured product data from local snapshots.
    ContentSnapshots.load('mortgageProduct').done(this._onLoadMortgageRateData.bind(this));

    // elements
    this._$node = $(this.node);

    this._$ratesContainer = this._$node.find('.mortgage-rates-comparison__their-rates');
    this._$selectProduct = this._$node.find("select[name='mortgage_product']");
    this._$ourRate = this._$node.find('.mortgage-rates-comparison__our-rate-field');
  };

  this.initAllReady = function () {
    this._$selectProduct.on('change', $.proxy(this._onSelectProduct, this));
  };

  this.destroy = function () {};

  this._onLoadMortgageRateData = function (data) {
    if (!this._$selectProduct.parents('body').length) return; // component was destroyed before it could be render data from contentful
    this._processRateData(data.items);
    ContentSnapshots.load('featuredMortgageProduct').done(this._onLoadFeaturedProductData.bind(this));
  };

  this._onLoadFeaturedProductData = function (data) {
    if (!this._$selectProduct.parents('body').length) return; // component was destroyed before it could be render data from contentful
    this._processFeatureData(data.items);

    this._$node.addClass('show');
    this._updateDisplayedProduct();
    if (this._$node.is(':visible')) {
      this.pushAnalytics();
    }

    this.onComplete(); // execte the callback once rates component is visible
  };

  this._processRateData = function (productsData) {
    for (var i = 0; i < productsData.length; i++) {
      var id = productsData[i]._id;
      var product = productsData[i];
      // create a map
      this._products[id] = product;
      this._$selectProduct.mogo().addOption(product.productName, id);
    }
  };

  this._processFeatureData = function (featureData) {
    // create featured product key
    if (featureData && featureData.length >= 1) {
      this._currentProduct = featureData[0].mortgageProduct._id;
    } else {
      this._currentProduct = productsData[0]._id; // if no featured product use the first product
    }
    this._$selectProduct.mogo().val(this._currentProduct);
  };

  this._onSelectProduct = function () {
    this._currentProduct = this._$selectProduct.val();
    this._updateDisplayedProduct();
    this.pushAnalytics(true);
  };

  this._createCompetitorElements = function () {
    var _this = this;

    this._$ratesContainer.empty();
    // populate competitors
    var competitors = this._products[this._currentProduct].competitorProducts;
    if (competitors) {
      $.each(competitors, function (key, competitor) {
        var html = "<div class='mortgage-rates-comparison__their-rate'>";
        html += '<div class=\'mortgage-rates-comparison__their-name\'>' + competitor.bank.shortName + '</div>';
        html += '<img class=\'mortgage-rates-comparison__their-logo\' src=\'' + competitor.bank.icon.file.url + '\' />';
        html += '<div class=\'mortgage-rates-comparison__their-rate-quantity\'>' + _this._padRate(competitor.annualInterestRate) + '</div>';
        html += '</div>';
        _this._$ratesContainer.append(html);
      });
    }
  };

  this._updateDisplayedProduct = function () {
    this._$ourRate.text(this._padRate(this._products[this._currentProduct].annualInterestRate));
    this._createCompetitorElements();
  };

  this.pushAnalytics = function (isSelectionChange) {
    // build list of competing bank names and rates then sort list by bank name
    var competingBanks = this._products[this._currentProduct].competitorProducts.slice(0);
    competingBanks.sort(function (a, b) {
      if (a.bank.shortName > b.bank.shortName) return 1;
      if (a.bank.shortName < b.bank.shortName) return -1;
      return 0;
    });
    var analyticsObject = {
      competingNames: [competingBanks.map(function (a) {
        return a.bank.shortName;
      })],
      competingRates: [competingBanks.map(function (a) {
        return a.annualInterestRate;
      })]
    };
    analyticsObject[!isSelectionChange ? 'featuredName' : 'selectedProduct'] = [this._products[this._currentProduct].productName];
    analyticsObject[!isSelectionChange ? 'featuredRate' : 'selectedRate'] = [this._products[this._currentProduct].annualInterestRate];
    this.analytics.pushEvent('mortgage-rates-view', analyticsObject);
  };

  this._padRate = function (rateValue) {
    return Number(rateValue).toFixed(2);
  };
}